import { inject, Injectable } from '@angular/core';
import { catchError, map, type Observable, of } from 'rxjs';
import { toDataResult, ToResult } from '@team23/ts-result';
import {
    FilterConfigService,
    type FilterDataResult,
    FilterDataStatus,
    MultiFilterModel,
} from '@ui/shared/util-filter';
import { AccessibilityFeatureOrderingEnum, CoreService } from '@ui/shared/util-api';
import type { SportMapFilterKey } from '../../types/sport-map-filter';

@Injectable({ providedIn: 'root' })
export class AccessibilitySelectFilterConfigService extends FilterConfigService<SportMapFilterKey, CoreService> {
    public override type = 'multiselect' as const;

    constructor() {
        super(
            new MultiFilterModel('accessibilityFeatures', 'Barrierefreiheit', []),
            inject(CoreService),
        );
    }

    protected _getOptions$(): Observable<FilterDataResult> {
        return this._api.getAllAccessibilityFeatures({
            order: [AccessibilityFeatureOrderingEnum.Name],
        })
            .pipe(
                map(result =>
                    result.data.map(dto => ({
                        value: dto.id,
                        label: dto.name,
                    })),
                ),
                toDataResult(),
                catchError(() => of(ToResult.fromErrorKey(FilterDataStatus.Generic))),
            );
    }
}
